import { render, staticRenderFns } from "./JobStatus.vue?vue&type=template&id=2a350574"
import script from "./JobStatus.vue?vue&type=script&lang=js"
export * from "./JobStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports